import React from "react";
import {lines} from "../../svgs/tokenomics/lines";

export default function Lines() {
  return (
    <>
      <div className="absolute -top-12 -left-[85%]">
        <img src={lines.tl} alt="tl" />
      </div>

      <div className="absolute -top-20 -left-[106%]">
        <img src={lines.l} alt="l" />
      </div>
      <div className="absolute top-8 -left-[80%] font-bold text-lg">
        Tax
        <br />
        <div className="text-xs font-normal mt-4 leading-6">
          2% on buy/sell
          <br />
          1% LP
          <br />
          1% Marketing
        </div>
      </div>

      <div className="absolute top-[360px] -left-[85%]">
        <img src={lines.bl} alt="bl" />
      </div>

      <div className="absolute top-2 -right-[77%]">
        <img src={lines.tr} alt="tr" />
      </div>

      <div className="absolute top-40 -right-[84%]">
        <img src={lines.r} alt="r" />
      </div>

      <div className="absolute bottom-0 -right-[65%] font-bold text-lg">
        <img src={lines.br} alt="br" />
      </div>
    </>
  );
}
